import dayjs from "dayjs";

// Custom quick filter function for non-string columns
const getQuickFilterFn =
  () => (quickFilterValue: unknown) => (value: unknown) => {
    return String(value ?? "")
      .toLowerCase()
      .includes(String(quickFilterValue).toLowerCase());
  };

// Convert stored "YYYY-MM-DD HH:mm username" to "YYYY-MM-DD hh:mm A username" for display.
// The raw 24-hour value is kept for lexicographic sorting.
const formatLastUpdatedDisplay = (value: unknown): string => {
  if (!value) return "";
  const str = String(value);
  // Match "YYYY-MM-DD HH:mm" at the start, rest is the username portion
  const match = str.match(/^(\d{4}-\d{2}-\d{2} \d{2}:\d{2})(.*)/);
  if (!match) return str;
  const parsed = dayjs(match[1], "YYYY-MM-DD HH:mm");
  if (!parsed.isValid()) return str;
  return `${parsed.format("YYYY-MM-DD hh:mm A")}${match[2]}`;
};

export const masterColumns = [
  {
    headerName: "#",
    field: "hoursCode",
    minWidth: 50,
    sortable: true,
    flex: 1,
    getApplyQuickFilterFn: getQuickFilterFn(),
  },
  {
    headerName: "Name",
    field: "hoursName",
    sortable: true,
    minWidth: 250,
    flex: 1,
  },
  {
    headerName: "Description",
    field: "description",
    sortable: true,
    minWidth: 250,
    flex: 1,
  },
  {
    headerName: "Last Updated",
    field: "lastUpdated",
    sortable: true,
    minWidth: 350,
    flex: 1,
    valueFormatter: (value: unknown) => formatLastUpdatedDisplay(value),
  },
];

export const detailColumns = [
  {
    label: "",
    id: "delete",
    flex: 1,
    minWidth: 44,
  },
  {
    label: "Day",
    id: "day",
    flex: 1,
    minWidth: 110,
    sortable: true,
  },
  {
    label: "Start",
    id: "start",
    flex: 1,
    minWidth: 130,
    sortable: true,
  },
  {
    label: "End",
    id: "end",
    flex: 1,
    minWidth: 130,
    sortable: true,
  },
  {
    label: "Open 24 Hours",
    id: "isOpenFor24Hours",
    flex: 1,
    minWidth: 135,
    sortable: false,
  },
];
